import { EnumReferralCodeStatus } from '@wallet-manager/pfh-pmp-node-def-types/dist/src/DbModel/Master';

export const getReferralCodeStatusDisplayValue = (
  value: number,
  translateFunc: (key: string) => string
) => {
  if (!EnumReferralCodeStatus[value]) return '';

  if (value === EnumReferralCodeStatus.Deleted) {
    return translateFunc('EnumReferralCodeStatus.Expired');
  }

  return translateFunc(`EnumReferralCodeStatus.${EnumReferralCodeStatus[value]}`);
};
